import { useRecoilCallback } from 'recoil'
import { canvasPageIdAtom } from '@/atoms/_editorAtoms'
import { caseAtom } from '@/atoms/caseAtoms'
import { editorCaseServiceIds } from '@/utils/editor-text-box/editorTextBoxAdapter'

/**
 * Reads, when called, what converting TinyMCE HTML into a Lotus box needs
 * from the editor: the page on the canvas, for the logs, and the case's
 * service ids, so a service block bound to a service the case lacks converts
 * unbound.
 */
export const useEditorHtmlConversionContext = () =>
  useRecoilCallback(
    ({ snapshot }) =>
      () => ({
        pageId: snapshot.getLoadable(canvasPageIdAtom).valueMaybe() ?? null,
        caseServiceIds: editorCaseServiceIds(
          snapshot.getLoadable(caseAtom).valueMaybe(),
        ),
      }),
    [],
  )
